module.exports = {
  ENV: 'prod',
  APP_NAME: 'atlanticeau',
  END_POINT: 'https://ssm.services.apihf.com',
  API_KEY: 'BQPDIf9QsM2Pj5zLAQ6VT9H9S71mmMt14NTcvXQH',
  BRAND_KEY: 'f62acbc6-7b2e-4580-bb62-c9a2ca6f07e4',
  CLIENT_ID: '2hcnhauq2qob6f67q6ikcb7of1',
  USER_POOL_ID: 'eu-west-1_HIn9p5IYR',
  HEADER_MESSAGE_SIZE: 41,
  AGENTS_GROUP: 'ATLANTICEAU_AGENTS',
}